// src/utils/exportAnalyticsExcel.js
// Writes a real .xlsx workbook (SheetJS) for one Analytics drill-down.
// SheetJS is loaded on demand so it stays out of the main bundle.

import { buildExportSheet, getExportFileName, METRICS } from "./guestRoomAnalytics";

export const buildAnalyticsWorkbook = (XLSX, metricKey, rows) => {
  const sheetRows = buildExportSheet(metricKey, rows);
  const worksheet = XLSX.utils.aoa_to_sheet(sheetRows);

  worksheet["!cols"] = sheetRows[0].map((_, col) => ({
    wch: Math.min(
      32,
      Math.max(10, ...sheetRows.map((r) => String(r[col] ?? "").length + 2))
    ),
  }));

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, METRICS[metricKey].title.slice(0, 31));
  return workbook;
};

export const exportAnalyticsExcel = async (metricKey, rows, now = new Date()) => {
  const XLSX = await import("xlsx");
  XLSX.writeFile(buildAnalyticsWorkbook(XLSX, metricKey, rows), getExportFileName(metricKey, now));
};
